import React from "react";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Menu from "@material-ui/core/Menu";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Viewer } from "components/auth/types";
import Navigation from "../navigation";

const useStyles = makeStyles(() =>
  createStyles({
    iconButton: {
      color: "white",
    },
  }));


const HamburgerMenu: React.FC<{viewer?: Viewer | null}> = ({ viewer }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <IconButton
        className={classes.iconButton}
        size="small"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}>
        <MenuIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Navigation viewer={viewer} mobile handleClose={handleClose}/>
      </Menu>
    </>
  );
};

export default HamburgerMenu;
